<template>
    <div>
        <el-form :model="transVoucherInfo" ref="ruleForm" :rules="rules">
            <div class="simple-form">
                <div class="form-group center" v-if="principalId != null && !transVoucherInfo.crossFlag">
                    <div class="form-label"></div>
                    <div class="form-value">
                        <el-checkbox v-model="transVoucherInfo.autoReceive">机构负责人自动领用</el-checkbox>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="transVoucherInfo.itemList" border tooltip-effect="dark">
                <el-table-column align="left" prop="title" label="耗材描述全称"></el-table-column>
                <el-table-column align="left" prop="model" width="180" label="型号"></el-table-column>
                <el-table-column align="left" prop="fixedSpec" width="180" label="规格"></el-table-column>
                <el-table-column align="left" prop="name" width="180" label="名称"></el-table-column>
                <el-table-column align="left" prop="catName" label="分类" width="120"></el-table-column>
                <el-table-column prop="groupName" label="分类分组" width="120" align="left" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{getGoodsCatDevcGroupName(rows.row.catId)}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="brandName" label="品牌" width="100"></el-table-column>
                <el-table-column align="left" prop="batchNo" label="批次号" width="150"></el-table-column>
                <el-table-column prop="dstComName" label="调入部门" width="140">
                    <template slot-scope="scope">
                        <span align="left" v-if="scope.row.dstComName != null">{{scope.row.dstComName}}</span>
                        <a class="swb-btn-link" align="right" @click="selectDstComName(scope.$index)">选择部门</a>
                    </template>
                </el-table-column>
                <el-table-column prop="dstWarehouseName" label="调入仓库" width="140" align="center">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.dstWarehouseId" placeholder="请选择" @change="selectDstWarehouse(scope.$index)">
                            <el-option v-for="item in wareHouseInList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="curQuantity" label="现存数量" width="80"></el-table-column>
                <el-table-column align="right" prop="quantity" label="调拨数量" width="80"></el-table-column>
                <el-table-column align="center" prop="theUnit" label="单位" width="60"></el-table-column>
                <el-table-column align="left" prop="memo" label="备注" width="100"></el-table-column>
            </el-table>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">确认描述</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input class="textarea-value" type="textarea" v-model="transVoucherInfo.confirmerDesc"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { openRetailComTreeSelectDlg } from '../retailer/selectDlg';
    import { getMerchantBizParam } from '../asset/assetMain'
    import { getDevcGroupNameByCatId } from '../index';
    import { openBizDepartDlg } from '../orgStruct/selectDlg'

    import shopStockApi from '../../api/shopStock'
    import retailerApi from '../../api/retailer'
    import assetVchrApi from '../../api/assetVchr'
    import shopStuffApi from '../../api/shopStuff'

    export default {
        name: 'swb-shop-device-trans-voucher-lowCost-confirm',
        desc: '调拨单确认',
        props: {
            id: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            return {
                transVoucherInfo: {},
                wareHouseInList: [],
                allotAcntTypeMap: getEnumMap("allotAcntType", "value2text"),
                allotAcntMethodMap: getEnumMap("allotAcntMethod", "value2text"),
            }
        },
        created: function () {
            let self = this;
            this.getShopStuffTransVoucher();
        },
        methods: {
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            getAllotAcntType: function (item, callBack) {
                let theLoad = MsgBox.loading();
                let postData = {
                    dstComId: item.dstComId,
                    srcComId: item.srcComId
                };
                assetVchrApi.getShopDeviceTransVoucherAllotAcntType(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        //
                        callBack(result.data)
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopStuffTransVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                shopStuffApi.getStuffTransVoucherInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let transVoucherInfo = result.data;
                        let comId = null;
                        let comName = null;
                        self.getRetailerComInfo(transVoucherInfo.dstBizUnitId, function (resullt) {
                            comId = resullt.id;
                            comName = resullt.name;
                        });
                        let itemList = transVoucherInfo.itemList || [];
                        itemList.forEach(function (item) {
                            if(Utils.isNoB(item.dstComId)) {
                                item.dstComId = comId;
                                item.dstComName = comName;
                            }
                        });
                        self.transVoucherInfo = transVoucherInfo;
                        self.getWarehouseList(transVoucherInfo.dstBizUnitId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getRetailerComInfo(id, callBack){
                retailerApi.getRetailerCom({id: id}, function (result) {
                    if(result.type == 'info') {
                        callBack(result.data);
                    }
                });
            },
            getRetailerCom(){
                let self = this;
                retailerApi.getRetailerCom({}, function (result) {
                    if(result.type == 'info') {
                        self.principalId = result.data.principalId;
                    }
                });
            },
            // 仓库信息
            getWarehouseList: function (dstBizUnitId) {
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.retailerShopId = dstBizUnitId;
                filterItems.locked = false;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.wareHouseInList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let transVoucherInfo = self.transVoucherInfo;
                let itemList = transVoucherInfo.itemList || [];
                let message = null;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(Utils.isNoB(item.dstWarehouseId)) {
                        message = "调入仓库不可为空";
                        break;
                    }
                    if(item.dstComId == item.srcComId && item.dstWarehouseId == item.srcWarehouseId) {
                        message = "调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨";
                        break;
                    }
                }
                if(!Utils.isNoB(message)) {
                    result.type = "warn";
                    result.message = message;
                } else {
                    let confirmVoucherInfo = {};
                    confirmVoucherInfo.id = self.id;
                    confirmVoucherInfo.autoReceive = transVoucherInfo.autoReceive || false;
                    confirmVoucherInfo.confirmState = 1;
                    confirmVoucherInfo.itemList = itemList;
                    result.type = "info";
                    result.data = confirmVoucherInfo;
                }
                return result;
            },
            selectDstComName: function (rowIndex) {
                let self = this;
                let transVoucherInfo = self.transVoucherInfo;
                let itemList = transVoucherInfo.itemList;
                let lowCostItem = itemList[rowIndex];
                openBizDepartDlg(transVoucherInfo.dstBizUnitId, function (result) {
                    lowCostItem.dstComId = result.id;
                    lowCostItem.dstComName = result.name;
                    if(lowCostItem.dstComId == lowCostItem.srcComId && lowCostItem.dstWarehouseId == lowCostItem.srcWarehouseId) {
                        MsgBox.warning("调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨");
                        return false;
                    }
                    self.getAllotAcntType(lowCostItem, function (result) {
                        lowCostItem.allotAcntType = result;
                        self.transVoucherInfo.itemList = Utils.merge([], itemList);
                    });
                })
            },
            selectDstWarehouse(rowIndex){
                let self = this;
                let transVoucherInfo = self.transVoucherInfo;
                let itemList = transVoucherInfo.itemList;
                let lowCostItem = itemList[rowIndex];
                if(lowCostItem.srcWarehouseId == lowCostItem.dstWarehouseId && lowCostItem.srcComId == lowCostItem.dstComId) {
                    MsgBox.warning("调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨");
                    return false;
                } else {
                    let dstWarehouseId = lowCostItem.dstWarehouseId;
                    let wareHouseInList = this.wareHouseInList;
                    let wareHouse = wareHouseInList.find(function (item) {
                        return item.id == dstWarehouseId;
                    });
                    lowCostItem.dstWarehouseName = wareHouse.name;
                    self.transVoucherInfo.itemList = Utils.merge([], itemList);
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherLowCostConfirm.vue